<template>
  <basic-selects
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="tasteKinds"
    :title="`${$t('title.selecttastekind')}`"
    idProperty="TasteKindId"
    nameProperty="TasteKindName"
    allSelectId="tasteKindAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :pagination="pagination"
    @getItems="getItems"
    :defaultItems="defaultItems"
    viewName="TasteKindSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      tasteKinds: [],
      columns: [
        {
          name: "TasteKindName",
        },
      ],
      id: "tasteKindSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    modalId: undefined,
    defaultItems: undefined,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(item) {
      this.$emit("onSaved", item);
    },
    getItems(dTO) {
      const vm = this;
      this.$api.tasteKinds.getPages(dTO).then((data) => {
        vm.tasteKinds = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
